import type { FaireProductEntity } from "../../entity_types/product";

export const p_g9ju46vmfb: FaireProductEntity = {
  token: "p_g9ju46vmfb",
  type: "product",
  name: "Cleansing Cloud | Detoxifying Whipped Tallow Balm",
  brandToken: "b_97fwzxfjvs",
  brandName: "Simply Happy",
  imageUrl:
    "https://cdn.faire.com/fastly/86999d564f196385ed0d88b464642933d813fbcf7677e18ef0a11c0f244536f9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8dd82625c17c1e4019d1a0e7735d5a93eccca179f5d656be1aee178186c7a3bc.jpeg",
    "https://cdn.faire.com/fastly/87097986214c20ac5197fb4a09ce8d1d43aac8f6523123afae33e38bfe3c7bdc.jpeg",
    "https://cdn.faire.com/fastly/e269e3e18e7a01e67ef07d67811faa34af1920c63c134a3b87f62cb075a05ebe.jpeg",
  ],
  priceDollars: 23.56,
  description:
    "Cleansing Cloud is a luxurious whipped cleansing balm handcrafted in Minnesota using tallow from grass-fed, grass-finished cattle raised on a regenerative farm. Blended with activated charcoal, mineral-rich clay, vitamin E, and tea tree oil, it deeply purifies and soothes the skin without stripping it.\n\nKey Benefits:\n✔️ Detoxifies with charcoal & clay\n✔️ Nourishes with antioxidant-rich tallow + vitamin E\n✔️ Clarifies and calms with tea tree oil\n✔️ Soft, whipped texture for gentle cleansing\n\nUse as a 15–20 minute mask, then rinse or wipe off. Use 1-2 times a week.\n\nOrganic ingredients: Grass-fed/finished tallow, organic cold-pressed olive oil, activated charcoal powder, kaolin clay, vitamin E, therapeutic-grade tea tree essential oil.\n\nPackaged in a reusable glass jar. Small-batch made in Minnesota.",
  tags: [],
  msrpDollars: 47.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:02:04.343Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
